import React from 'react';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
  FacebookIcon,
  LinkedinIcon,
  EmailIcon,
} from 'react-share';

// Custom X (formerly Twitter) Icon component
const XIcon = ({ size, round, style }) => (
  <div
    style={{
      ...style,
      width: size,
      height: size,
      backgroundColor: '#000000',
      borderRadius: round ? '50%' : '0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: Math.round(size * 0.25),
      lineHeight: 0,
      position: 'relative',
      top: '0px',
    }}
  >
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: 'block',
        transform: 'scale(1.1)',
        position: 'relative',
        top: '0px',
      }}
    >
      <path
        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
        fill="#FFFFFF"
      />
    </svg>
  </div>
);

function SocialShare({ url, title }) {
  return (
    <div
      className="social-share-container"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        lineHeight: 0,
      }}
    >
      <FacebookShareButton url={url} quote={title}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>

      <TwitterShareButton url={url} title={title}>
        <XIcon size={32} round />
      </TwitterShareButton>

      <LinkedinShareButton url={url}>
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>

      <EmailShareButton url={url} subject={title} body="Check out this page: ">
        <EmailIcon size={32} round />
      </EmailShareButton>
    </div>
  );
}

export default SocialShare;
